/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { TemplateMedidaCriteriaDto } from '../models/template-medida-criteria-dto';
import { TemplateMedidaDto } from '../models/template-medida-dto';
import { TemplateMedidaFormDto } from '../models/template-medida-form-dto';
import { TemplateMedidaPageDto } from '../models/template-medida-page-dto';


/**
 * Templates medida
 */
@Injectable({
  providedIn: 'root',
})
export class TemplatesMedidaService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getTemplatesMedida
   */
  static readonly GetTemplatesMedidaPath = '/templates-medida';

  /**
   * Pesquisar templates medida.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTemplatesMedida()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTemplatesMedida$Response(params?: {
    criteria?: TemplateMedidaCriteriaDto;
  }): Observable<StrictHttpResponse<TemplateMedidaPageDto>> {

    const rb = new RequestBuilder(this.rootUrl, TemplatesMedidaService.GetTemplatesMedidaPath, 'get');
    if (params) {
      rb.query('criteria', params.criteria, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TemplateMedidaPageDto>;
      })
    );
  }

  /**
   * Pesquisar templates medida.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getTemplatesMedida$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTemplatesMedida(params?: {
    criteria?: TemplateMedidaCriteriaDto;
  }): Observable<TemplateMedidaPageDto> {

    return this.getTemplatesMedida$Response(params).pipe(
      map((r: StrictHttpResponse<TemplateMedidaPageDto>) => r.body as TemplateMedidaPageDto)
    );
  }

  /**
   * Path part for operation createTemplateMedida
   */
  static readonly CreateTemplateMedidaPath = '/templates-medida';

  /**
   * Criar template medida.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createTemplateMedida()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createTemplateMedida$Response(params?: {
    body?: TemplateMedidaFormDto
  }): Observable<StrictHttpResponse<TemplateMedidaDto>> {

    const rb = new RequestBuilder(this.rootUrl, TemplatesMedidaService.CreateTemplateMedidaPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TemplateMedidaDto>;
      })
    );
  }

  /**
   * Criar template medida.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createTemplateMedida$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createTemplateMedida(params?: {
    body?: TemplateMedidaFormDto
  }): Observable<TemplateMedidaDto> {

    return this.createTemplateMedida$Response(params).pipe(
      map((r: StrictHttpResponse<TemplateMedidaDto>) => r.body as TemplateMedidaDto)
    );
  }

  /**
   * Path part for operation getTemplateMedida
   */
  static readonly GetTemplateMedidaPath = '/templates-medida/{id}';

  /**
   * Obter template medida.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTemplateMedida()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTemplateMedida$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<TemplateMedidaDto>> {

    const rb = new RequestBuilder(this.rootUrl, TemplatesMedidaService.GetTemplateMedidaPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TemplateMedidaDto>;
      })
    );
  }

  /**
   * Obter template medida.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getTemplateMedida$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTemplateMedida(params: {
    id: number;
  }): Observable<TemplateMedidaDto> {

    return this.getTemplateMedida$Response(params).pipe(
      map((r: StrictHttpResponse<TemplateMedidaDto>) => r.body as TemplateMedidaDto)
    );
  }

  /**
   * Path part for operation updateTemplateMedida
   */
  static readonly UpdateTemplateMedidaPath = '/templates-medida/{id}';

  /**
   * Atualizar template medida.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateTemplateMedida()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTemplateMedida$Response(params: {
    id: number;
    body?: TemplateMedidaFormDto
  }): Observable<StrictHttpResponse<TemplateMedidaDto>> {

    const rb = new RequestBuilder(this.rootUrl, TemplatesMedidaService.UpdateTemplateMedidaPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TemplateMedidaDto>;
      })
    );
  }

  /**
   * Atualizar template medida.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateTemplateMedida$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTemplateMedida(params: {
    id: number;
    body?: TemplateMedidaFormDto
  }): Observable<TemplateMedidaDto> {

    return this.updateTemplateMedida$Response(params).pipe(
      map((r: StrictHttpResponse<TemplateMedidaDto>) => r.body as TemplateMedidaDto)
    );
  }

  /**
   * Path part for operation ativarTemplateMedida
   */
  static readonly AtivarTemplateMedidaPath = '/templates-medida/{id}/ativar';

  /**
   * Ativar template medida.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ativarTemplateMedida()` instead.
   *
   * This method doesn't expect any request body.
   */
  ativarTemplateMedida$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<TemplateMedidaDto>> {

    const rb = new RequestBuilder(this.rootUrl, TemplatesMedidaService.AtivarTemplateMedidaPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TemplateMedidaDto>;
      })
    );
  }

  /**
   * Ativar template medida.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `ativarTemplateMedida$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ativarTemplateMedida(params: {
    id: number;
  }): Observable<TemplateMedidaDto> {

    return this.ativarTemplateMedida$Response(params).pipe(
      map((r: StrictHttpResponse<TemplateMedidaDto>) => r.body as TemplateMedidaDto)
    );
  }

  /**
   * Path part for operation desativarTemplateMedida
   */
  static readonly DesativarTemplateMedidaPath = '/templates-medida/{id}/desativar';

  /**
   * Desativar template medida.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `desativarTemplateMedida()` instead.
   *
   * This method doesn't expect any request body.
   */
  desativarTemplateMedida$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<TemplateMedidaDto>> {

    const rb = new RequestBuilder(this.rootUrl, TemplatesMedidaService.DesativarTemplateMedidaPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TemplateMedidaDto>;
      })
    );
  }

  /**
   * Desativar template medida.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `desativarTemplateMedida$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  desativarTemplateMedida(params: {
    id: number;
  }): Observable<TemplateMedidaDto> {

    return this.desativarTemplateMedida$Response(params).pipe(
      map((r: StrictHttpResponse<TemplateMedidaDto>) => r.body as TemplateMedidaDto)
    );
  }

}
